import React from "react";
import BaseSection from "../components/BaseSection";
import { IoMdPersonAdd, IoMdRemoveCircleOutline } from "react-icons/io";
import { Grid } from "@material-ui/core";
import TextInput from "../components/Input/TextInput";

export const MANAGER_SECTION_INPUTS = {
  NEW_MANAGER_NAME: "new_manager_name",
  NEW_MANAGER_EMAIL: "new_manager_email",
  MANAGERS: "managers",
  MANAGERS_EMAILS_TO_REMOVE: "manager_emails_to_remove"
};

export default function ManagerSection({
  inputs = {},
  errors = {},
  isEditing = false,
  onChangeInput = () => null,
}) {
  const managers = Array.isArray(inputs[MANAGER_SECTION_INPUTS.MANAGERS])
    ? inputs[MANAGER_SECTION_INPUTS.MANAGERS]
    : [];

  const handleRemoveManager = (managerToRemove) => {
    onChangeInput(MANAGER_SECTION_INPUTS.MANAGERS_EMAILS_TO_REMOVE, [...inputs[MANAGER_SECTION_INPUTS.MANAGERS_EMAILS_TO_REMOVE], managerToRemove.email]);
    onChangeInput(MANAGER_SECTION_INPUTS.MANAGERS, managers.filter(manager => manager.id !== managerToRemove.id));
  }

  return (
    <BaseSection
      title={isEditing ? "Gestores do LMS" : "Cadastro de gestor"}
      Icon={<IoMdPersonAdd />}
    >
      <Grid container spacing={3}>
        {managers?.length > 0 &&
          isEditing &&
          managers.map((manager) => {
            return (
              <Grid item container spacing={3} key={manager.id}>
                <Grid item xs={6}>
                  <TextInput
                    label="Nome do Gestor"
                    type="text"
                    readOnly
                    value={manager.name}
                  />
                </Grid>
                <Grid item xs={6}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <TextInput
                      label="Email do Gestor"
                      type="text"
                      value={manager.email}
                      readOnly
                      fullWidth
                    />
                    <button
                      title="Remover Gestor. Essa ação é irreversível"
                      type="button"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#ff0000",
                        display: "flex",
                        alignItems: "center",
                        paddingTop: "1.75rem",
                        cursor: 'pointer'
                      }}
                      onClick={() => handleRemoveManager(manager)}
                    >
                      <IoMdRemoveCircleOutline size="1.25em" />
                    </button>
                  </div>
                </Grid>
              </Grid>
            );
          })}
        <Grid item container spacing={3}>
          <Grid item xs={6}>
            <TextInput
              label={
                isEditing ? "Nome do novo Gestor (Opcional)" : "Nome do Gestor"
              }
              type="text"
              placeholder="Nome do Gestor a ser cadastrado"
              name={MANAGER_SECTION_INPUTS.NEW_MANAGER_NAME}
              value={inputs[MANAGER_SECTION_INPUTS.NEW_MANAGER_NAME]}
              errorMessage={errors[MANAGER_SECTION_INPUTS.NEW_MANAGER_NAME]}
              onChange={(e) =>
                onChangeInput(
                  MANAGER_SECTION_INPUTS.NEW_MANAGER_NAME,
                  e.target.value
                )
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextInput
              label={
                isEditing
                  ? "Email do novo Gestor (Opcional)"
                  : "Email do Gestor"
              }
              type="text"
              placeholder="Email do Gestor a ser cadastrado"
              name={MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL}
              value={inputs[MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL]}
              errorMessage={errors[MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL]}
              onChange={(e) =>
                onChangeInput(
                  MANAGER_SECTION_INPUTS.NEW_MANAGER_EMAIL,
                  e.target.value
                )
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </BaseSection>
  );
}
